import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-layout-map',
  templateUrl: './layout-map.component.html',
  styleUrls: ['./layout-map.component.scss']
})
export class LayoutMapComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
